import { render } from "./DepEdPersonnelsDataTable.vue?vue&type=template&id=3b34d0d7"
import script from "./DepEdPersonnelsDataTable.vue?vue&type=script&lang=js"
export * from "./DepEdPersonnelsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__